import { useTranslation } from 'react-i18next';
import { CheckCircleIcon, XCircleIcon } from '@phosphor-icons/react';
import { PASSWORD_CRITERIA } from '../../constants/validation';

interface PasswordStrengthIndicatorProps {
  password: string;
}

export const PasswordStrengthIndicator = ({ password }: PasswordStrengthIndicatorProps) => {
  const { t } = useTranslation();

  if (!password) return null;

  const hasMinLength = password.length >= PASSWORD_CRITERIA.minLength;
  const hasLowercase = PASSWORD_CRITERIA.hasLowercase.test(password);
  const hasUppercase = PASSWORD_CRITERIA.hasUppercase.test(password);
  const hasNumber = PASSWORD_CRITERIA.hasNumber.test(password);
  const hasSpecialChar = PASSWORD_CRITERIA.hasSpecialChar.test(password);

  const rules = [
    {
      valid: hasMinLength,
      label: t('auth.password_rules.min_length', { count: PASSWORD_CRITERIA.minLength }),
    },
    {
      valid: hasLowercase,
      label: t('auth.password_rules.lowercase'),
    },
    {
      valid: hasUppercase,
      label: t('auth.password_rules.uppercase'),
    },
    {
      valid: hasNumber,
      label: t('auth.password_rules.number'),
    },
    {
      valid: hasSpecialChar,
      label: t('auth.password_rules.special_char'),
    },
  ];

  return (
    <div className="mt-2 space-y-1">
      {rules.map((rule, index) => (
        <div key={index} className="flex items-center gap-2 text-sm">
          {rule.valid ? (
            <CheckCircleIcon size={16} weight="fill" className="text-green-500 flex-shrink-0" />
          ) : (
            <XCircleIcon size={16} weight="fill" className="text-red-500 flex-shrink-0" />
          )}
          <span className={rule.valid ? 'text-green-700' : 'text-red-700'}>{rule.label}</span>
        </div>
      ))}
    </div>
  );
};
